import React, { useEffect, useState } from 'react';
import GeneratePdf from '../../../../components/GeneratePdf';
import { getFormatedNumber } from '../../../../services/appService';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useDispatch, useSelector } from 'react-redux';
import { getCandidateVisaStatusRpt, loadCandidateVisaStatusRpt } from '../../../store/reports';
import Moment from 'react-moment';

const CandidateVisaStatus = () => {

    const [selectedEntityType, setSelectedEntityType] = useState(0);
    const [visaExpired, setVisaExpired] = useState(0);
    const [candidateVisaReports, setCandidateVisaReports] = useState([]);
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);
    const [visaType, setVisaType] = useState("");


    const entityTypes = [
        { id: 1, name: "C2C Candidate", pmId: 67 },
        { id: 2, name: "W2 Candidate", pmId: 69 },
        { id: 3, name: "1099 Candidate", pmId: 70 },
    ];

    const visaStatus = [
        { value: "H1B", label: "H1B" },
        { value: "EAD_GC", label: "EAD-GC" },
        { value: "TN", label: "TN" },
        { value: "Green_C", label: "Green Card" },
        { value: "US_Citizen", label: "US Citizen" },
        { value: "H4_EAD", label: "H4 EAD" },
        { value: "F1_OPT", label: "F1-OPT" },
        { value: "F1_CPT", label: "F1-CPT" },
        { value: "L1", label: "L1" },
        { value: "Canadian Citizen", label: "Canadian Citizen" }
    ];

    const candidateVisaStatusRpt = useSelector(getCandidateVisaStatusRpt);

    const dispatch = useDispatch();

    useEffect(() => {
        setCandidateVisaReports(candidateVisaStatusRpt);
    }, [candidateVisaStatusRpt]);


    const handlepdfShowHide = () => {
        setPdfShowHide(!pdfShowHide);
    }

    const candidateVisaExportPDF = () => {
        let headers = [
            [
                "ID",
                "Name",
                "Email",
                "Phone",
                "Visa Type",
                "Visa Expiration Date",
                "Visa Status",
            ],
        ];

        let data = [];
        candidateVisaReports.filter(x => x.visaType === visaType || visaType === "").map((item) => {
            let visaExpirationStatus = 3; // default: Data not submitted

            if (item.visaExpiration) {
                const expDate = new Date(item.visaExpiration);
                const today = new Date();
                // Compare only dates (ignore time)
                const expDateOnly = new Date(expDate.toDateString());
                const todayOnly = new Date(today.toDateString());

                visaExpirationStatus = expDateOnly < todayOnly ? 1 : 2; // 1 = Expired, 2 = Active
            }
            data.push([
                item.keyId,
                item.keyName,
                item.keyEmail,
                item.keyPhone,
                visaStatus.find((v) => v.value === item.visaType)
                    ?.label || 'N/A',
                item.visaExpiration,
                visaExpirationStatus === 1
                    ? "Expired"
                    : visaExpirationStatus === 2
                        ? "Active"
                        : "",
            ])
        });
        setSelectedCol(headers);
        setSelectedColData(data);
        handlepdfShowHide();
    }

    const handleEntityTypeChange = (e) => {
        setSelectedEntityType(e.target.value);
    }

    const handleVisaExpiredChange = (e) => {
        setVisaExpired(e.target.value);
    }

    const handleGenerateRpt = () => {
        // Logic to generate report based on selectedEntityType and visaExpired
        dispatch(loadCandidateVisaStatusRpt(selectedEntityType, visaExpired, 0, 0));
    }

    const handleVisaTypeChange = (e) => {
        setVisaType(e.target.value);
    }

    return (
        <>

            <div className="card shadow-none border">
                <div className="card-header text-center p-3 bg-lighter">
                    <h4 className="mb-0">
                        Candidate Visa Status Reports
                    </h4>
                </div>
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-2">
                            <select
                                name="insuranceType"
                                id="insuranceType"
                                className="form-control form-control-sm"
                                onChange={handleEntityTypeChange}
                                value={selectedEntityType}
                            >
                                <option value="0">Select Entity</option>
                                {entityTypes.map((y) => (
                                    <option value={y.pmId}>
                                        {y.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select
                                name="visaType"
                                id="visaType"
                                className="form-control form-control-sm"
                                onChange={handleVisaTypeChange}
                                value={visaType}
                            >
                                <option value="">All Visa Type</option>
                                {visaStatus.map((visa) => (
                                    <option value={visa.value}>{visa.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select
                                name="insuranceExpired"
                                id="insuranceExpired"
                                className="form-control form-control-sm"
                                onChange={handleVisaExpiredChange}
                                value={visaExpired}
                            >
                                <option value="0">Select Expiration</option>
                                <option value="1">Expired</option>
                                <option value="2">Active</option>
                                <option value="3">Data not submitted</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-sm btn-outline-default"
                                disabled={selectedEntityType === 0}
                                onClick={handleGenerateRpt}
                            >
                                Generate
                            </button>
                        </div>
                        <div className="col-md-4 text-right">
                            <ReactHTMLTableToExcel
                                id="subcontractorTable"
                                className="btn btn-sm btn-outline-default"
                                table="sub_ach_rpt"
                                filename="insurance_Report"
                                sheet="insurance_Report"
                                buttonText="Export to Excel"
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-default"
                                disabled={candidateVisaReports?.length === 0}
                                onClick={candidateVisaExportPDF}
                            >
                                Generate PDF
                            </button>
                        </div>
                        <div className="col-md-12 mt-3">
                            <div className="table-responsive">
                                <table
                                    className="table align-items-center table-flush table-hover table-striped mb-2 border"
                                    id="sub_ach_rpt"
                                >
                                    <thead className="thead-light">
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Visa Type</th>
                                            <th>Visa Expiration Date</th>
                                            <th>Visa Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {candidateVisaReports?.filter(x => x.visaType === visaType || visaType === "").map((item) => {
                                            // --- Compute Visa Expiration Status ---
                                            let visaExpirationStatus = 3; // default: Data not submitted

                                            if (item.visaExpiration) {
                                                const expDate = new Date(item.visaExpiration);
                                                const today = new Date();

                                                // Compare only dates (ignore time)
                                                const expDateOnly = new Date(expDate.toDateString());
                                                const todayOnly = new Date(today.toDateString());

                                                visaExpirationStatus = expDateOnly < todayOnly ? 1 : 2; // 1 = Expired, 2 = Active
                                            }

                                            return (
                                                <tr key={item.keyId}>
                                                    <td>{item.keyId}</td>
                                                    <td>{item.keyName}</td>
                                                    <td>{item.keyEmail}</td>
                                                    <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                                    <td>
                                                        {
                                                            visaStatus.find((v) => v.value === item.visaType)
                                                                ?.label || 'N/A'
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.visaExpiration && (
                                                            <Moment format="MMM Do YYYY">{item.visaExpiration}</Moment>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {visaExpirationStatus === 1 && (
                                                            <span>Expired</span>
                                                        )}
                                                        {visaExpirationStatus === 2 && (
                                                            <span>Active</span>
                                                        )}
                                                        {visaExpirationStatus === 3 && (
                                                            <span></span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <GeneratePdf
                handlepdfShowHide={handlepdfShowHide}
                pdfShowHide={pdfShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GeneratePdf>

        </>
    );
};

export default CandidateVisaStatus;